import { Divider } from 'antd';
import NormalSchedule from '../location/hours/NormalSchedule';
import { SpecialSchedule } from '../location/hours/SpecialSchedule';

export const RegularScheduleTab = ({ location}: any) => {
    return (
        <NormalSchedule location={location} />
    );
};
